import { FC } from "react";
import { useAppSelector } from "../../../../../../../../../../../store/hooks";
import { TotalCostColumnHeaderCell } from "../../../../../../../../../resource-explorer/components/resource-explorer-card/components/resource-explorer-data-grid/components/columns/components/common/TotalCostColumnHeaderCell";
import { costBreakdownV2WidgetSetupTotalCostSelector } from "../../../../../../../../../../../store/dashboards/selectors/widgets/cost-breakdown-v2/setup/costBreakdownV2WidgetSetupTotalCostSelector";

export const CostBreakdownV2WidgetSetupTableTotalCostHeaderCell: FC = () => {
  const total = useAppSelector(costBreakdownV2WidgetSetupTotalCostSelector);

  return (
    <TotalCostColumnHeaderCell
      totalCost={total?.cost ?? 0}
      dateDetails={total?.dateDetails}
    />
  );
};
